import { createApi } from '@reduxjs/toolkit/dist/query/react';

import serverRoutes from '@app/utils/server-routes';

import {
  QmUsersListRequestType,
  QmUsersListWithRolesType,
  QmUsersRolesListType,
  QmUserWithRoleType,
} from '@app/interfaces/qm-users.type';

import { baseQuery } from '../../../baseQuery';

export const qmUsersApi = createApi({
  reducerPath: 'qmUsersApi',
  tagTypes: ['qmUsersList', 'qmUser'],
  baseQuery: baseQuery,
  endpoints: (build) => ({
    getUsersListWithRoles: build.query<QmUsersListWithRolesType, QmUsersListRequestType>({
      query: (params) => ({
        url: serverRoutes.qm_users_with_roles_bulk,
        params,
      }),
      providesTags: ['qmUsersList'],
    }),
    getUserWithRoles: build.query<QmUserWithRoleType, { id: string }>({
      query: (params) => ({
        url: serverRoutes.qm_users_with_roles,
        params,
      }),
      providesTags: ['qmUser'],
    }),
    setQmUserRole: build.mutation<
      QmUserWithRoleType,
      { params: { id: string }; body: { qm_role: QmUsersRolesListType; qm_operator_id?: string } }
    >({
      query: ({ params, body }) => ({
        url: serverRoutes.qm_users_with_roles_role_set,
        params,
        body,
        method: 'PUT',
      }),
      invalidatesTags: ['qmUsersList', 'qmUser'],
    }),
    setQmUserOperatorId: build.mutation<
      QmUserWithRoleType,
      { params: { id: string }; body: { qm_operator_id: string } }
    >({
      query: ({ params, body }) => ({
        url: serverRoutes.qm_users_with_roles_operator_set,
        params,
        body,
        method: 'PUT',
      }),
      invalidatesTags: ['qmUsersList', 'qmUser'],
    }),
  }),
});

export const {
  useGetUsersListWithRolesQuery,
  useLazyGetUsersListWithRolesQuery,
  useLazyGetUserWithRolesQuery,
  useSetQmUserRoleMutation,
  useSetQmUserOperatorIdMutation,
} = qmUsersApi;
